import { useTranslation } from "react-i18next";
import { BookingPageFormDialogContentsSectionForm } from "./types";
import { Input, Label } from "@tellescope/ui";

export interface AnalyticsSectionProps {
  form: BookingPageFormDialogContentsSectionForm<"gtmTag" | "ga4measurementId">;
}

export const AnalyticsSection = ({ form }: AnalyticsSectionProps) => {
  const { t } = useTranslation("calendar");

  return (
    <section className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="gtmTag">{t("Google Tag Manager Tag")}</Label>
        <Input {...form.getFieldProps("gtmTag")} id="gtmTag" placeholder={t("GTM-XXXXXX")} />
        <p className="text-xs text-muted-foreground font-light">{t("Enter your Google Tag Manager container ID")}</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="ga4measurementId">{t("Google Analytics 4 Measurement ID")}</Label>
        <Input {...form.getFieldProps("ga4measurementId")} id="ga4measurementId" placeholder={t("G-XXXXXXXXXX")} />
        <p className="text-xs text-muted-foreground font-light">{t("Enter your GA4 measurement ID for tracking")}</p>
      </div>
      <div className="bg-gray-100 rounded-sm space-y-2 p-4">
        <p className="text-normal text-sm">{t("Analytics Setup")}</p>
        <p className="text-normal text-xs text-muted-foreground">
          {t(
            "These analytics tools will track booking page interactions, conversions, and user behavior. Make sure you have the appropriate consent mechanisms in place for data collection."
          )}
        </p>
      </div>
    </section>
  );
};
